import type { ReactNode } from 'react'
import { Icon, type IconName } from '../../../components/icons/Icon'

export interface EmptyStateProps {
  icon: IconName
  title: string
  description?: string | undefined
  action?: ReactNode | undefined
}

/** Shared shape for the empty-tenant and empty-filtered states. */
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--iw-space-3)',
        padding: 'var(--iw-space-7) var(--iw-space-5)',
        textAlign: 'center',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: 'var(--iw-neutral-100)',
          color: 'var(--iw-text-subtle)',
        }}
      >
        <Icon name={icon} size={22} />
      </span>
      <div>
        <p style={{ margin: 0, fontWeight: 'var(--iw-weight-medium)' as never, color: 'var(--iw-text)' }}>{title}</p>
        {description ? (
          <p style={{ margin: '4px 0 0', fontSize: 'var(--iw-size-sm)', color: 'var(--iw-text-muted)' }}>
            {description}
          </p>
        ) : null}
      </div>
      {action}
    </div>
  )
}
